import { useEffect } from "react";
import { BrowserRouter, Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Doc from "@/pages/Doc";
import Triage from "@/pages/Triage";
import Brief from "@/pages/Brief";
import Mockup from "@/pages/mockup/Mockup";
import About from "@/pages/mockup/About";
import Approach from "@/pages/mockup/Approach";
import ImpactIndex from "@/pages/mockup/ImpactIndex";
import ImpactStory from "@/pages/mockup/ImpactStory";
import InsightsPage from "@/pages/mockup/InsightsPage";
import Conversation from "@/pages/mockup/Conversation";
import Donate from "@/pages/mockup/Donate";
import Careers from "@/pages/mockup/Careers";
import SearchPage from "@/pages/mockup/SearchPage";
import { Privacy, Terms, Accessibility } from "@/pages/mockup/Legal";
import { Printer } from "lucide-react";

const Header = () => (
  <header className="doc-topbar">
    <div className="topbar-inner">
      <div>
        <p className="topbar-org">HARC — Houston Advanced Research Center</p>
        <p className="topbar-doc">Website Architecture Recommendation</p>
      </div>
      <nav className="topnav" aria-label="Deliverables">
        <NavLink to="/internal" end data-testid="nav-recommendation">
          Recommendation
        </NavLink>
        <NavLink to="/internal/triage" data-testid="nav-triage">
          Content Triage
        </NavLink>
        <NavLink to="/internal/brief" data-testid="nav-brief">
          Approval Brief
        </NavLink>
        <NavLink to="/" end data-testid="nav-mockup">
          Homepage Mockup
        </NavLink>
        <button
          type="button"
          className="print-btn"
          data-testid="print-document-button"
          onClick={() => window.print()}
        >
          <Printer size={15} strokeWidth={2.2} aria-hidden="true" />
          Print / PDF
        </button>
      </nav>
    </div>
  </header>
);

const LegacyRedirect = () => {
  const { pathname } = useLocation();
  return <Navigate to={pathname.replace(/^\/mockup/, "") || "/"} replace />;
};

const Chrome = () => {
  const { pathname } = useLocation();
  const isInternal = pathname.startsWith("/internal");

  useEffect(() => {
    document.title = isInternal
      ? "HARC | Website Architecture Recommendation"
      : "HARC | Where Science Creates Solutions";
    const theme = document.querySelector('meta[name="theme-color"]');
    if (theme) theme.setAttribute("content", "#004778");
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png";
      document.head.appendChild(link);
    }
    link.href = "/favicon.png";
  }, [isInternal]);

  return (
    <>
      {isInternal && <Header />}
      <Routes>
        <Route path="/" element={<Mockup />} />
        <Route path="/about" element={<About />} />
        <Route path="/approach" element={<Approach />} />
        <Route path="/impact" element={<ImpactIndex />} />
        <Route path="/impact-story" element={<ImpactStory />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/start-a-conversation" element={<Conversation />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/accessibility" element={<Accessibility />} />
        <Route path="/internal" element={<Doc />} />
        <Route path="/internal/triage" element={<Triage />} />
        <Route path="/internal/brief" element={<Brief />} />
        <Route path="/mockup" element={<Navigate to="/" replace />} />
        <Route path="/mockup/*" element={<LegacyRedirect />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Chrome />
    </BrowserRouter>
  );
}

export default App;
